<!--
 * @Author: Lemon C
 * @Date: 2025-01-14 13:07:12
 * @LastEditTime: 2025-01-14 14:16:55
-->
<template>
    <el-image :src="image_url">
        <template #placeholder>
            <div class="image-slot">
                <img class="img-ph" :src="image_ph_url" />
            </div>
        </template>
    </el-image>
</template>

// MOD-- JavaScript
<script setup>
import { ref, watch, onMounted } from 'vue';

defineOptions({
    name: 'ReImg',
});

const props = defineProps({
    src: {
        type: String,
        default: '',
    },
    ph: {
        type: String,
        default: '@/assets/imgs/logo/logo_black.png',
    },
});

const image_url = ref('');
const image_ph_url = ref('');

watch([() => props.src, () => props.ph], () => {
    image_url.value = props.src;
    image_ph_url.value = props.ph;
});

onMounted(() => {
    image_url.value = props.src;
    image_ph_url.value = props.ph;
});
</script>

// MOD-- CSS
<style lang="less" scoped>
.img-ph {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
</style>
